import { render } from "./POSStationModal.vue?vue&type=template&id=547b9f1a&scoped=true"
import script from "./POSStationModal.vue?vue&type=script&lang=js"
export * from "./POSStationModal.vue?vue&type=script&lang=js"

import "./POSStationModal.vue?vue&type=style&index=0&id=547b9f1a&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547b9f1a"]])

export default __exports__